<template>
    <div>
        <WebSocket :url="webSocketUrl" @receive-message="receiveMessage"></WebSocket>
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('k110') }}</div>
            <div>
                <p class="warning">{{ getTranslation('k111') }}</p>
            </div>
            <template v-if="softUpgrading">
                <div class="upgrade-progress-container menu-actions">
                    <!-- 进度条区域 -->
                    <div class="progress-section">
                        <div class="progress-circle">
                            <i-circle :size="100" :percent="calProgress" :stroke-width="8" stroke-color="#1890ff">
                                <span class="circle-percent">{{ calProgress }}%</span>
                            </i-circle>
                        </div>
                    </div>                    
                    <!-- 进度信息区域 -->
                    <div class="progress-info-section">
                        <div class="progress-status">
                            <div :class="clsStatustitle">{{ progressTitle }}</div>
                            <div class="progress-count">{{ calSuccess }}/{{ calTotal }}</div>
                        </div>
                        
                        <!-- 错误信息区域 -->
                        <div class="error-section" v-if="progressError">
                            <div class="error-icon">
                                <Icon type="ios-warning" size="20" color="#f5222d" />
                            </div>
                            <div class="error-message">
                                <span class="error-text">{{ progressError }}</span>
                                <Button
                                    type="primary"
                                    size="small"
                                    @click.native="retry()"
                                    class="retry-btn"
                                    icon="ios-refresh">
                                    {{ getTranslation('m119') }}
                                </Button>
                            </div>
                        </div>
                    </div>
                    
                    <!-- 操作按钮区域 -->
                    <div class="action-section">
                        <Button type="primary" icon="md-close" :disabled="!canClose" @click.native="closeUpgrade()" size="small">
                            {{ getTranslation('m063') }}
                        </Button>
                    </div>
                </div>
            </template>
            <template v-else>
                <Row class="limit-line menu-actions" type="flex">
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('k112') }}
                        </Col>
                        <Col flex="2">
                        <Upload name="file" :action="softwareUpgrade" :before-upload="handleUpload"
                            :show-upload-list="true" :on-remove="handleRemove" :default-file-list="fileList"
                            accept=".bin">
                            <div style="padding: 4px 0">
                                <Button type="info" icon="ios-cloud-upload-outline" size="small">{{ getTranslation('k114') }}</Button>
                            </div>
                        </Upload>
                        </Col>
                    </Row>
                    </Col>
                    <Col flex="1">
                    </Col>
                </Row>
                <Row class="limit-line" type="flex">
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('m203') }}
                        </Col>
                        <Col flex="2">
                        <Input class="input-field" type="password" password v-model="softPassword" />
                        </Col>
                    </Row>
                    </Col>
                    <Col flex="1">
                    </Col>
                </Row>

                <Row class="limit-line menu-actions" type="flex">
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1">
                        </Col>
                        <Col flex="2">
                        <Button type="warning" size="small" @click.native="upgrade()" :loading="loadingStatus"
                            :disabled="upgradeDisabled" icon="ios-cloud-upload-outline">{{ getTranslation('k115')
                            }}</Button>&nbsp;
                        </Col>
                    </Row>
                    </Col>
                    <Col flex="1">
                    </Col>
                </Row>
            </template>
        </Card>
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('k116') }}</div>
            <div>
                <p class="warning">{{ getTranslation('k117') }}</p>
            </div>
            <Row class="limit-line" type="flex">
                <Col flex="1">
                <Row class="limit-line" type="flex">
                    <Col flex="1" class="left-program desc-field">{{ getTranslation('k118') }}
                    </Col>
                    <Col flex="2">
                    <Checkbox v-model="prg">{{ getTranslation('k002') }}</Checkbox>
                    <!--<Checkbox v-model="sys">{{ getTranslation('k119') }}({{ getTranslation('e067') }})</Checkbox>-->
                    </Col>
                </Row>
                </Col>
                <Col flex="1">
                </Col>
            </Row>
            <Row class="limit-line" type="flex">
                <Col flex="1">
                <Row class="limit-line" type="flex">
                    <Col flex="1" class="left-program desc-field">{{ getTranslation('m203') }}
                    </Col>
                    <Col flex="2">
                    <Input class="input-field" type="password" password v-model="resetPassword" />
                    </Col>
                </Row>
                </Col>
                <Col flex="1">
                </Col>
            </Row>
            <Row class="limit-line" type="flex">
                <Col flex="1">
                <Row class="limit-line menu-actions" type="flex">
                    <Col flex="1">
                    </Col>
                    <Col flex="2">
                    <Button type="error" @click.native="reset()" size="small" icon="ios-refresh">{{ getTranslation('m028')
                        }}</Button>&nbsp;
                    <template v-if="progress && progress == 988888">&nbsp;{{ getTranslation('s327') }}
                    </template>
                    <template v-else-if="progress && progress == 999999">&nbsp;{{ getTranslation('s328') }}
                    </template>
                    <template v-else-if="progress && progress > 0">&nbsp;{{ getTranslation('s330') }}
                    </template>
                    </Col>
                </Row>
                </Col>
                <Col flex="1">
                </Col>
            </Row>
        </Card>
    </div>
</template>
<script>

import { Card, Row, Col, Button, Input, Upload, Checkbox, Circle,Icon } from "view-design"
import WebSocket from '@/components/WebSocket.vue';
import axios from 'axios'
import { API_URL } from '@/constants/const.js'
import { mapGetters } from 'vuex'
import { postJsError } from '@/util/util.js'
export default {
    name: 'SoftUpgrade', // 组件名称
    components: {
        Card, Row, Col, Button, Input, Upload, Checkbox, WebSocket,Icon,
        'i-circle': Circle,
    },
    props: {
        kind: {
            type: Number,
            default: 803
        },
        progress: {
            type: Number,
            default: null
        },
    },
    data() {
        return {
            info: {},
            mac: 0,
            softPassword: '',
            loadingStatus: false,
            prg: false,
            sys: false,
            resetPassword: '',
            fileList: [],
            softUpgrading: false,
            progressJson: null,

        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        softwareUpgrade() {
            return API_URL["systemSoftwareUpgrade"] + '?mac=' + this.mac;
        },
        upgradeDisabled() {
            return !this.fileList || this.fileList.length == 0
        },
        webSocketUrl() {
            return API_URL['webSocket'] + "?mac=" + this.$route.query.mac;
        },
        calProgress() {
            if (this.progressJson && this.progressJson.total > 0) {
                let percent = Math.floor((this.progressJson.processed / this.progressJson.total) * 100);
                return percent;
            } else {
                return 0;
            }
        },
        calSuccess() {
            if (this.progressJson) {
                let successCount = this.progressJson.processed;
                return successCount;
            } else {
                return 0;
            }
        },
        calTotal() {
            if (this.progressJson) {
                return this.progressJson.total;
            } else {
                return 0;
            }
        },
        progressTitle(){
        let rs = this.getTranslation('m120');
        if(this.progressJson ){
            switch(this.progressJson.status){
                case 'upgrading':
                rs = this.getTranslation('m116');
                break;
                case 'success':
                rs = this.getTranslation('m117');
                break;
                case 'failed':
                rs = this.getTranslation('m118');
                break;
                default:
                rs = this.getTranslation('m120');
            }            
        }
        return rs;
        },
         progressError(){
        let rs = '';
        if(this.progressJson &&  this.progressJson.error ){
            rs = this.progressJson.error;
        }
        return rs;
        },
        canClose(){
            let rs = true;
            if(this.progressJson && (this.progressJson.status == 'upgrading' ||  this.progressJson.status == 'waiting')){
                rs = false;
            }           
            return rs 
        },
        clsStatustitle(){
            let rs = 'status-title-waiting';
            if(this.progressJson ){
                switch(this.progressJson.status){
                    case 'upgrading':
                    rs = 'status-title-upgrading';
                    break;
                    case 'success':
                    rs = 'status-title-success';
                    break;
                    case 'failed':
                    rs = 'status-title-failed';
                    break;
                    default:
                    rs = 'status-title-waiting';
                }            
            }
            return rs; 
        } 
    },
    watch: {

    },

    created() {
        this.init();
    },
    methods: {
        init() {
            this.mac = this.$route.query.mac
        },
        handleUpload(file) {
            // 将文件添加到文件列表
            this.fileList = [file];
            // 返回 false 阻止自动上传，但文件会显示在列表中
            return false;
        },
        handleRemove() {
            // 当用户点击删除按钮时，清空文件列表
            this.fileList = [];
        },
        upgrade() {
            this.loadingStatus = true;
            this.progressJson =null;
            const formData = new FormData()
            let url = API_URL["systemSoftwareUpgrade"] + '?mac=' + this.mac;
            formData.append('file', this.fileList[0])
            formData.append('password', this.softPassword)
            axios.post(url,
                formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
                }
            )
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.loadingStatus = false;
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    } else {
                        this.$Message.error(this.getTranslation('c001'));
                    }
                    this.loadingStatus = false;
                })
                .catch((err) => {
                    postJsError(err)
                    this.loadingStatus = false;
                    this.$Message.error(this.getTranslation('c001'));
                })
        },
        reset() {
            this.$Modal.confirm({
                title: "",
                content: this.getTranslation('m069'),
                okText: this.getTranslation('b181'),
                cancelText: this.getTranslation('b182'),
                onOk: () => {
                    const formData = new FormData()
                    let url = API_URL["systemSoftwareReset"] + '?mac=' + this.mac;
                    formData.append('prg', this.prg)
                    formData.append('sys', this.sys)
                    formData.append('password', this.resetPassword)
                    axios.post(url,
                        formData
                    )
                        .then(res => {
                            if (res && res.data && res.data.code == 200) {
                                this.$Message.success(res.data.msg);
                            } else if (res && res.data && res.data.msg) {
                                this.$Message.error(res.data.msg);
                            } else {
                                this.$Message.error(this.getTranslation('c001'));
                            }

                        })
                        .catch((err) => {
                            postJsError(err)
                            this.$Message.error(this.getTranslation('c001'));
                        })
                }
            });
        },
        receiveMessage(obj) {
            if (obj && obj.kind == 'upgradeProgress' && obj.data && obj.data.device_progress && obj.data.device_progress[this.mac]) {
              this.softUpgrading = true;
              if (!this.progressJson || this.progressJson.processed <=  obj.data.device_progress[this.mac].processed) {
                //避免进度发送错乱时，进度回退
                this.progressJson = obj.data.device_progress[this.mac];                
              }
            }

        },
        closeUpgrade() {
            this.fileList = [];
            this.progressJson = null;
            this.softUpgrading = false;
            this.softPassword = '';
            this.loadingStatus = false;
        },
        retry(){
            this.upgrade();
        },
    }

}
</script>

<style scoped>
@import url('../../../assets/style/list.css');
@import url('../../../assets/style/tab.css');

.warning {
    color: red;
}

.progress-text {
    font-size: 14px;
    color: #515a6e;
    font-weight: 500;
}

/* 升级进度容器样式 */
.upgrade-progress-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 8px;
    margin-bottom: 16px;
    gap: 24px;
}

/* 进度条区域 */
.progress-section {
    flex-shrink: 0;
}

.progress-circle {
    text-align: center;
}

.circle-percent {
    font-size: 16px;
    font-weight: bold;
    color: #1890ff;
}

/* 进度信息区域 */
.progress-info-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.progress-status {
    text-align: left;
}

.status-title-upgrading {
    font-size: 18px;
    font-weight: 600;
    color: #1890ff;
    margin-bottom: 8px;
    text-shadow: 0 1px 2px rgba(24, 144, 255, 0.1);
}
.status-title-success {
    font-size: 18px;
    font-weight: 600;
    color: #52c41a;
    margin-bottom: 8px;
    text-shadow: 0 1px 2px rgba(24, 144, 255, 0.1);
}
.status-title-failed {
    font-size: 18px;
    font-weight: 600;
    color: #f5222d;
    margin-bottom: 8px;
    text-shadow: 0 1px 2px rgba(24, 144, 255, 0.1);
}
.status-title-waiting {
    font-size: 18px;
    font-weight: 600;
    color: #515a6e;
    margin-bottom: 8px;
    text-shadow: 0 1px 2px rgba(24, 144, 255, 0.1);
}


.progress-count {
    font-size: 16px;
    color: #52c41a;
    font-weight: 600;
    background: linear-gradient(135deg, #52c41a, #73d13d);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    padding: 4px 8px;
    border-radius: 4px;
    display: inline-block;
    box-shadow: 0 2px 4px rgba(82, 196, 26, 0.2);
}

/* 错误信息区域 */
.error-section {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: linear-gradient(135deg, #fff2f0, #fff9f8);
    border: 1px solid #ffccc7;
    border-radius: 8px;
    margin-top: 12px;
    box-shadow: 0 2px 8px rgba(255, 77, 79, 0.1);
    position: relative;
    overflow: hidden;
}

.error-section::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: linear-gradient(to bottom, #ff4d4f, #ff7875);
    border-radius: 4px 0 0 4px;
}

.error-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
}

.error-icon .ivu-icon {
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}

.error-message {
    font-size: 14px;
    color: #a8071a;
    line-height: 1.3;
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.error-text {
    flex: 1;
    min-width: 200px;
    font-weight: 500;
    text-shadow: 0 1px 2px rgba(168, 7, 26, 0.1);
}

.retry-btn {
    background: linear-gradient(135deg, #52c41a, #73d13d);
    border: none;
    border-radius: 6px;
    box-shadow: 0 2px 6px rgba(82, 196, 26, 0.3);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    font-weight: 600;
    padding: 6px 16px;
    height: auto;
    min-width: 80px;
    color: white;
    letter-spacing: 0.5px;
    position: relative;
    overflow: hidden;
}

.retry-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
}

.retry-btn:hover {
    background: linear-gradient(135deg, #389e0d, #52c41a);
    box-shadow: 0 4px 12px rgba(82, 196, 26, 0.4);
    transform: translateY(-1px);
}

.retry-btn:hover::before {
    left: 100%;
}

.retry-btn:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(82, 196, 26, 0.3);
}

.retry-btn .ivu-icon {
    margin-right: 4px;
    font-size: 14px;
    transition: transform 0.3s ease;
}

.retry-btn:hover .ivu-icon {
    transform: rotate(180deg);
}

/* 响应式设计优化 */
@media (max-width: 768px) {
    .error-section {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
    
    .error-message {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
    
    .error-text {
        min-width: auto;
    }
    
    .retry-btn {
        align-self: stretch;
        text-align: center;
    }
}

/* 操作按钮区域 */
.action-section {
    flex-shrink: 0;
    display: flex;
    align-items: center;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .upgrade-progress-container {
        flex-direction: column;
        text-align: center;
        gap: 16px;
    }
    
    .progress-info-section {
        text-align: center;
    }
    
    .error-section {
        justify-content: center;
    }
}
</style>